module.exports = __webpack_public_path__ + "static/assets/fd2022f573561d6fcc1102f49fccf615.png";